export function changeLoading(loading) {
	return {
		type: "@register/CHANGE_LOADING",
		payload: {
			loading,
		},
	};
}

export function onboardingGogogoRequest(password, isTermAccepted, event, tokenRecaptchaRegister, adid) {
	return {
		type: "@register/ONBOARDING_GOGOGO_REQUEST",
		payload: { password, isTermAccepted, event, tokenRecaptchaRegister, adid },
	};
}

export function onboardingGogogoRequestStep(password, isTermAccepted, isEduca = false) {
	return {
		type: "@register/ONBOARDING_GOGOGO_REQUEST_STEP",
		payload: { password, isTermAccepted, isEduca },
	};
}

/**
 *
 * @param {string} field
 * @param {string} _value
 * @param {boolean} extra
 * @param {boolean} is_edition
 * @returns
 */
export function updateOnboardFieldRequest(field, _value, extra, is_edition) {
	return {
		type: "@register/UPDATE_ONBOARD_FIELD_REQUEST",
		payload: { field, _value, extra, is_edition },
	};
}

/**
 *  @deprecated
 */
export function onboardValidatingEmailResponse(resp) {
	return {
		type: "@register/ONBOARD_VALIDATING_EMAIL_RESPONSE",
		payload: { resp },
	};
}

export function updateChecoutRegisterFieldRequest(field, value, extra) {
	return {
		type: "@register/UPDATE_CHECKOUT_REGISTER_FIELD_REQUEST",
		payload: { field, value, extra },
	};
}

export function newInvestorRequest(info) {
	return {
		type: "@register/ONBOARDING_NEW_INVESTOR",
		payload: { info },
	};
}

export function changeCreatedStatus(status) {
	return {
		type: "@register/ONBOARDING_NEW_INVESTOR_STATUS",
		payload: { status },
	};
}

export function verifyDuplicityEmailRequest(email, cpfInvestor) {
	return {
		type: "@register/VALIDATING_EMAIL",
		payload: {
			email,
			cpfInvestor,
		},
	};
}

export function verifyDuplicityEmailResp(resp) {
	return {
		type: "@register/VALIDATING_EMAIL_RESP",
		payload: { resp },
	};
}

export function acceptedTerms(isTermAccepted) {
	return {
		type: "@register/ACCEPTED_TERMS",
		payload: { isTermAccepted },
	};
}

export function setVerificatedEmailDuplicity(result) {
	return {
		type: "@register/SET_VERIFICATED_EMAIL_DUPLICITY",
		payload: { result },
	};
}

export function initialOnboarding() {
	return {
		type: "@register/INITIAL_ONBOARDING",
		payload: {},
	};
}

export function initialOnboardingResponse(resp) {
	return {
		type: "@register/INITIAL_ONBOARDING_RESPONSE",
		payload: { resp },
	};
}

/**
 *
 * @param {string} cd_access_token
 * @param {string} type
 * @param {string} value
 * @param {object} header
 * @returns
 */
export function validateInitialOnboardingEmail(cd_access_token, type, value, header) {
	return {
		type: "@register/VALIDATE_INITIAL_ONBOARDING_EMAIL",
		payload: { cd_access_token, type, value, header },
	};
}

/**
 *
 * @param {{cd_access_token:string, type:string, value:string, header: object}} payload
 * @returns
 */
export function validateInitialOnboardingPhone(payload) {
	return {
		type: "@register/VALIDATE_INITIAL_ONBOARDING_PHONE",
		payload,
	};
}

export function validateInitialOnboardingResponse(data) {
	return {
		type: "@register/VALIDATE_INITIAL_ONBOARDING_RESPONSE",
		payload: data,
	};
}

/**
 *
 * @param {{cd_access_token: string, is_term_accepted: boolean, cd_channel: string, password: string, adid: string, tokenRecaptcha: object, event: string}} payload
 * @returns
 */
export function onboardGogogoV2(payload) {
	return {
		type: "@register/ONBOARD_GOGOGO_V2_REQUEST",
		payload,
	};
}

/**
 *
 * @param {{cd_access_token: string}} payload
 * @returns
 */
export function getEmailProductActivationRequest(payload) {
	return {
		type: "@register/GET_EMAIL_PRODUCT_ACTIVATIONS_REQUEST",
		payload,
	};
}

export function getResponseUpdateOnboardField(param) {
	return {
		type: "@register/GET_RESPONSE_UPDATE_ONBOARD_FIELD",
		payload: { param },
	};
}

export function loginByOnboardGogogoRequest(password, event = null, tokenRecaptchaRegister, adid) {
	return {
		type: "@register/LOGIN_BY_ONBOARD_GOGOGO",
		payload: { password, event, tokenRecaptchaRegister, adid },
	};
}

export function sendingToMarket(param) {
	return {
		type: "@register/SENDING_TO_MARKET",
		payload: { param },
	};
}

/**
 *  @deprecated
 */
export function updateOnboardFieldsRequest(fields) {
	return {
		type: "@register/UPDATE_ONBOARD_FIELDS_REQUEST",
		payload: { fields },
	};
}

/**
 *  @deprecated
 */
export function updatedAllFields(updated_all_fields) {
	return {
		type: "@register/UPDATED_ALL_FIELDS",
		payload: { updated_all_fields },
	};
}

export function sendTicket(payload) {
	return {
		type: "@register/TICKET_ZENDESK_REQUEST",
		payload,
	};
}

export function responseTicket(payload) {
	return {
		type: "@register/TICKET_ZENDESK_RESPONSE",
		payload,
	};
}

export function sendTicketLoading(payload) {
	return {
		type: "@register/SEND_TICKET_LOADING",
		payload,
	};
}

/**
 *
 * @param {{cd_access_token: string, email: string, verification: string}} payload
 * @returns
 */
export function emailConfirmationRequest(payload) {
	return {
		type: "@register/EMAIL_CONFIRMATION_REQUEST",
		payload,
	};
}

/**
 *
 * @param {string} err
 * @returns
 */
export function setEmailConfirmationError(err) {
	return {
		type: "@register/EMAIL_CONFIRMATION_ERROR",
		payload: err,
	};
}

/**
 *
 * @param {{cd_access_token: string, vl_full_phone_number: string, verification: string}} payload
 * @returns
 */
export function phoneConfirmationRequest(payload) {
	return {
		type: "@register/PHONE_CONFIRMATION_REQUEST",
		payload,
	};
}

/**
 *
 * @param {string} err
 * @returns
 */
export function setPhoneConfirmationError(err) {
	return {
		type: "@register/PHONE_CONFIRMATION_ERROR",
		payload: err,
	};
}

/**
 *
 * @param {{cd_access_token, vl_full_phone_number}} payload
 * @returns
 */
export function resendPhoneConfirmationRequest(payload) {
	return {
		type: "@register/RESEND_PHONE_CONFIRMATION_REQUEST",
		payload,
	};
}
